import Vue from 'vue';
import Buefy from 'buefy';

import BasicInfo from './App.vue'



Vue.use(Buefy, {
    defaultIconPack: 'fas',
  })
Vue.use(BasicInfo)

if (document.getElementById("basicInfoApp")){
    new Vue({
        render: h => h(
            BasicInfo,{
                props:{
                    details:document.getElementById("basicInfoApp")
                        .getAttribute("details")
                }
            }
        )
    }).$mount("#basicInfoApp")
}